import React, { Component } from 'react';
import PageHeader from '../../components/PageHeader';
import SEO from '../../components/SEO';
import Layout from '../../layout';

import CTA2 from '../../components/CTA';
import Inspector from './_inspector';

class Page extends Component {
  render() {
    return (
      <Layout>
        <SEO
          title="HTML Form inspector"
          keywords={['']}
          pathname={this.props.location.pathname}
          description="Paste your HTML form code to get a detailed overview of its structure and fields."
          ogFileName="forminspector"
          ogCustomPath="/og-custom/"
          imageDescription=""
        />
        <PageHeader>
          <h1>HTML Form Inspector</h1>
          <h2>Paste your HTML form code to get a detailed overview of its structure and fields.</h2>
        </PageHeader>

        <Inspector />
        <CTA2 />
      </Layout>
    );
  }
}

export default Page;
